import { render, staticRenderFns } from "./mailAddress.vue?vue&type=template&id=1074730c"
import script from "./mailAddress.vue?vue&type=script&lang=js"
export * from "./mailAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports